import { Box, HStack, IconButton, Spacer, Tooltip } from "@chakra-ui/react";
import { PlusIcon } from "lucide-react";
import React, { ReactNode, useEffect, useState } from "react";

export interface AdminToolbarProps {
  onOpen?: () => void;
  onClose?: () => void;
  hidden?: boolean;
  children: ReactNode;
}

const AdminToolbar: React.FC<AdminToolbarProps> = ({
  onOpen,
  onClose,
  hidden,
  children,
}: AdminToolbarProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleToolbar = () => {
    setIsOpen((oldState) => !oldState);
  };

  useEffect(() => {
    if (isOpen && onOpen != undefined) {
      onOpen();
    }
    if (!isOpen && onClose != undefined) {
      onClose();
    }
  }, [isOpen]);

  if (hidden) {
    return null;
  }

  return (
    <Box
      position="relative"
      top="0"
      height={isOpen ? "80px" : "80px"}
      backgroundColor={isOpen ? "gray.600" : "transparent"}
      padding={isOpen ? 4 : 2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      borderRadius={isOpen ? "10px" : "50%"}
      transition="width 0.3s ease-in-out, padding 0.3s ease-in-out, border-radius 0.3s ease-in-out,  background-color 0.3s ease-in-out"
      width={isOpen ? "100%" : "80px"}
      marginBottom={"20px"}
      marginTop={"20px"}
    >
      <Tooltip
        hasArrow
        label="Admin tools"
        bg="gray.300"
        color="black"
        hidden={isOpen}
      >
        <IconButton
          aria-label="Toggle Toolbar"
          icon={<PlusIcon />}
          isRound={true}
          onClick={toggleToolbar}
          size={"lg"}
          colorScheme={isOpen ? "red" : "green"}
          transform={isOpen ? "rotate(45deg)" : "rotate(0deg)"}
        />
      </Tooltip>

      {isOpen && (
        <HStack marginLeft={"10px"} width={"100%"} spacing={4}>
          <Spacer />
          {children}
        </HStack>
      )}
    </Box>
  );
};

export default AdminToolbar;
